<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i-discovery">
<h1 style="padding-top:200px; font-family:arial"><img alt="" src="media/a.jpg"/><br/><br/>Part I <br/>Discovery</h1>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?0576de87